import e from "@dialpad/dialtone-tokens/layered/themes/tokens-105-colors.css?inline";
//#region themes/105.js
var t = { brand: {
	css: e,
	name: "105"
} };
//#endregion
export { t as default };
